import { Target } from 'lucide-react';

interface ProfileObjectivesProps {
  profile: { objectives?: string[] };
}

const OBJECTIVES: Record<string, { icon: string; label: string }> = {
  language: { icon: '🗣️', label: 'Ameliorer une langue' },
  career: { icon: '💼', label: 'Faire evoluer sa carriere' },
  travel: { icon: '🌎', label: 'Voyager et explorer' },
  nature: { icon: '🌿', label: 'Experience en pleine nature' },
  culture: { icon: '🎉', label: 'Decouvrir la culture locale & faire la fete' }
};

export function ProfileObjectives({ profile }: ProfileObjectivesProps) {
  if (!profile.objectives || profile.objectives.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="flex items-center gap-2.5 mb-4">
        <Target className="w-5 h-5 text-gray-400 dark:text-gray-500" />
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Objectifs du PVT</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {profile.objectives.map((objectiveId) => {
          const objective = OBJECTIVES[objectiveId];
          if (!objective) return null;
          return (
            <div
              key={objectiveId}
              className="flex items-center gap-3 p-3.5 rounded-xl bg-gray-50 dark:bg-gray-700/30 border border-gray-100 dark:border-gray-700/50"
            >
              <span className="text-xl flex-shrink-0">{objective.icon}</span>
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300 leading-snug">
                {objective.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
